export enum AtButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GRAYSCALE = 'grayscale',
  TERTIARY = 'tertiary',
}

export enum AtButtonDimensions {
  MEDIUM = 'medium',
  LARGE = 'large',
  SMALL = 'small',
  SMALLER = 'smaller',
}

export enum AtButtonBehaviors {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}
